import Icon from './Icon';

const Link = (props) => {
  const { color, ...rest } = props;
  return (
    <Icon
      {...rest}
      title="Save"
      viewBox="0 0 20 21"
      path="M14.125 5.87732L5.875 14.1273"
      stroke={color || 'var(--color-text-primary)'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path
        d="M8.33325 5.83545L14.1249 5.87628L14.1666 11.6688"
        stroke={color || 'var(--color-text-primary)'}
        fill="none"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};
export default Link;
